export default __webpack_public_path__ + "static/media/click-left.0e6f9878.svg";